var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6875 0H8.3125V1.32362C4.94272 1.90549 2.375 4.92189 2.375 8.55556V11.0001L0 14.6668L1.1875 18.3333H17.8125L19 14.6667L16.625 11V8.55556C16.625 4.92189 14.0573 1.90549 10.6875 1.32362V0ZM14.25 11.7401L16.3796 15.0279L16.1007 15.8889H2.89929L2.62045 15.0279L4.75 11.7403V8.55573C4.75 5.85567 6.87665 3.66667 9.5 3.66667C12.1234 3.66667 14.25 5.8555 14.25 8.55556V11.7401Z",
    fill: "#8834FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22C10.8117 22 11.875 20.9056 11.875 19.5556H7.125C7.125 20.9056 8.18832 22 9.5 22Z",
    fill: "#8834FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActiveIcon);
export default __webpack_public_path__ + "static/media/bellActiveIcon.2a6baedf6162ceb9185cb028b2a6683f.svg";
export { ForwardRef as ReactComponent };